import React from 'react';
import Navbar from '../components/Navbar';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

function Contact() {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="container section-padding" style={{ paddingTop: '8rem' }}>
        <div className="text-center" style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h1 className="gradient-text" style={{ fontSize: '3.5rem' }}>Get in Touch</h1>
          <p className="text-muted" style={{ fontSize: '1.2rem' }}>Our team would love to hear from you. Send us a message!</p>
        </div>

        <div className="grid" style={{ gridTemplateColumns: 'minmax(300px, 1fr) minmax(300px, 2fr)', gap: 'var(--spacing-xl)' }}>
          
          {/* Contact Info */}
          <div className="flex flex-col gap-lg">
            <div className="card glass flex gap-md items-center">
              <div style={{ color: 'var(--color-primary)' }}><Mail size={32} /></div>
              <div>
                <h4 style={{ marginBottom: 0 }}>Email Us</h4>
                <p className="text-muted">support@learnly.com</p>
              </div>
            </div>
            
            <div className="card glass flex gap-md items-center">
              <div style={{ color: 'var(--color-accent-blue)' }}><Phone size={32} /></div>
              <div>
                <h4 style={{ marginBottom: 0 }}>Call Us</h4>
                <p className="text-muted">+1 (555) 123-4567</p>
              </div>
            </div>
            
            <div className="card glass flex gap-md items-center">
              <div style={{ color: 'var(--color-accent-purple)' }}><MapPin size={32} /></div>
              <div>
                <h4 style={{ marginBottom: 0 }}>Headquarters</h4>
                <p className="text-muted">123 SaaS Avenue, Tech District, SF, CA</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="card glass" style={{ padding: 'var(--spacing-xl)' }}>
            <form className="flex flex-col gap-md" onSubmit={(e) => e.preventDefault()}>
              <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 'var(--spacing-md)' }}>
                <div className="flex flex-col gap-xs">
                  <label style={{ fontWeight: 500, color: 'var(--color-text-primary)' }}>First Name</label>
                  <input type="text" placeholder="John" style={{ padding: '12px', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', outline: 'none' }} />
                </div>
                <div className="flex flex-col gap-xs">
                  <label style={{ fontWeight: 500, color: 'var(--color-text-primary)' }}>Last Name</label>
                  <input type="text" placeholder="Doe" style={{ padding: '12px', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', outline: 'none' }} />
                </div>
              </div>
              
              <div className="flex flex-col gap-xs">
                <label style={{ fontWeight: 500, color: 'var(--color-text-primary)' }}>Email Address</label>
                <input type="email" placeholder="john@example.com" style={{ padding: '12px', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', outline: 'none', width: '100%' }} />
              </div>
              
              <div className="flex flex-col gap-xs">
                <label style={{ fontWeight: 500, color: 'var(--color-text-primary)' }}>Message</label>
                <textarea rows="5" placeholder="How can we help?" style={{ padding: '12px', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', outline: 'none', width: '100%', resize: 'vertical' }}></textarea>
              </div>
              
              <button type="submit" className="btn btn-primary w-full" style={{ marginTop: 'var(--spacing-sm)' }}>
                Send Message <Send size={18} style={{ marginLeft: '8px' }}/>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
